import { render, staticRenderFns } from "./CouponInput.vue?vue&type=template&id=861d0be0&"
import script from "./CouponInput.vue?vue&type=script&lang=js&"
export * from "./CouponInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports